angular.module('app.registration.confirmation.confirmationService', [])
    .factory('app.registration.confirmation.confirmationService', [
        '$http',
        function ($http) {
            return {
                confirm: function (user_id, confirmation_code) {
                    return $http.put(window.location.api('users_confirm'), {
                        user_id: user_id,
                        confirmation_code: confirmation_code
                    });
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/registration/confirmation/confirmationService.js